module.exports = __webpack_public_path__ + "static/media/icon-phone-black.86d31fe4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-phone-black.svg
// module id = 1473
// module chunks = 0